<template>
  <div>
    <v-dialog v-model="isOpen" width="500" persistent>
      <v-card>
        <v-btn icon @click="onClose" class="modal-close-icon">
          <v-icon class="grey--text">mdi-close</v-icon>
        </v-btn>
        <div class="modal-body" id="success-modal-body">
          <v-card-title
            class="headline white modal-title green--text"
            primary-title
          >
            {{ title }}
          </v-card-title>

          <div class="modal-content" ref="content">
            <div
              class="summary-wrapper grey lighten-3 pa-4 mx-4 mb-3 text-xs-left"
            >
              <v-layout row wrap>
                <v-flex xs6>
                  <div class="col-6 grey--text">
                    Transaction Time
                  </div>
                </v-flex>
                <v-flex xs6>
                  <div class="col-6 green--text">
                    {{ summary.created_date }}
                  </div>
                </v-flex>
              </v-layout>
            </div>

            <div
              class="summary-wrapper grey lighten-3 pa-4 mx-4 mb-3 text-xs-left"
            >
              <v-layout row wrap>
                <v-flex xs6>
                  <div class="col-6 grey--text">
                    Order Number
                  </div>
                </v-flex>
                <v-flex xs6>
                  <div class="col-6 green--text">
                    {{ summary.distributor_balance_order_number }}
                  </div>
                </v-flex>
              </v-layout>
            </div>

            <div
              class="summary-wrapper grey lighten-3 pa-4 mx-4 mb-3 text-xs-left"
            >
              <v-layout row wrap>
                <v-flex xs6>
                  <div class="col-6 grey--text">
                    Nominal
                  </div>
                </v-flex>
                <v-flex xs6>
                  <div class="col-6 green--text">{{ summary.amount }}</div>
                </v-flex>
              </v-layout>
            </div>

            <div
              class="summary-wrapper grey lighten-3 pa-4 mx-4 mb-3 text-xs-left"
            >
              <v-layout row wrap>
                <v-flex xs6>
                  <div class="col-6 grey--text">
                    Payment Fee
                  </div>
                </v-flex>
                <v-flex xs6>
                  <div class="col-6 green--text">
                    {{ summary.va_payment_fee }}
                  </div>
                </v-flex>
              </v-layout>
            </div>

            <div
              class="summary-wrapper grey lighten-3 pa-4 mx-4 mb-3 text-xs-left"
            >
              <v-layout row wrap>
                <v-flex xs6>
                  <div class="col-6 green--text">
                    <p class="mb-0 font-weight-bold">Total Transfer</p>
                  </div>
                </v-flex>
                <v-flex xs6>
                  <div class="col-6 green--text">
                    <p class="mb-0 font-weight-bold subheading">
                      {{ summary.va_gross_amount }}
                    </p>
                  </div>
                </v-flex>
              </v-layout>
            </div>
          </div>
        </div>
        <v-card-actions class="pa-4 d-flex">
          <Invoice :summary="summary" :onPrepare="appendTempInvoiceToDOM" />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Invoice from '@/components/Invoice.vue'

export default {
  name: 'SuccessTopUpModal',
  components: { Invoice },
  data () {
    return {}
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    onClose: {
      type: Function,
      default: () => {}
    },
    title: {
      type: String,
      default: 'Modal Title'
    },
    summary: {
      type: Object,
      default: () => {}
    }
  },
  computed: {},
  methods: {
    appendTempInvoiceToDOM () {
      const appDOM = document.getElementById('topup-content-wrapper')
      const invoiceDOM = document.getElementById('invoice-pdf')

      appDOM.appendChild(invoiceDOM)
    }
  }
}
</script>
<style scoped>
.modal-body {
  padding: 2em;
  text-align: left;
}

.modal-close-icon {
  float: right;
  margin: 1em;
}

.modal-title {
  font-weight: 600;
  font-size: 1.5em !important;
}

.v-card__title {
  padding: 1em;
  margin-bottom: 1em;
  margin-top: 1em;
}

.summary-wrapper {
  border-radius: 10px;
}
</style>
